import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from 'src/app/shared/components/base/base.component';
import {MatTabGroup} from '@angular/material';
import {AsEnterpriseService} from '../../../../../core/services/as-enterprise.service';
import {EnterpriseService} from '../../../../../core/services/enterprise.service';
import {CommonService} from '../../../../../core/services/common.service';
import {Message} from '../../../../../core/class/message';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DigitalCertificateService} from '../../../../../core/services/digital-certificate.service';
import {WarningComponent} from '../../../../../shared/components/warning/warning.component';
import {MatDialog} from '@angular/material/dialog';
import { AutoUserService } from 'src/app/core/services/auto-user.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import {EnterpriseNotificationEnterpriseComponent} from './enterprise-notification-enterprise/enterprise-notification-enterprise.component';

@Component({
  selector: 'app-enterprise-notification',
  templateUrl: './enterprise-notification.component.html',
  styleUrls: ['./enterprise-notification.component.scss']
})
export class EnterpriseNotificationComponent extends BaseComponent implements OnInit, OnDestroy {
  isInforTab = 0;
  isActive: boolean = false;
  nzCheckLoadingUser = false;
  form: FormGroup;
  inputUserSignValue: string;
  filteredUserOptions = [];
  users: any[] = [];
  columnDefinitions = [ 'STT', 'name', 'email', 'phoneNumber', 'action' ];
  isFormChanging:boolean = false;
  scopeType = this.commonService.checkEnterpriseType() ? 2 : 1;
  idConfig: string = '';
  enterpriseId = localStorage.getItem('enterpriseId');
  constructor(private enterpriseService: EnterpriseService ,
              public commonService: CommonService,
              private dialog: MatDialog,
              public message: Message,
              public autoUserService: AutoUserService,
              private fb: FormBuilder,
              private toastr: ToastrService,
              private router: Router,
              ) {
    super(commonService, message);
    this.form = this.fb.group({
      isSendSms: [false],
      isSendEmail: [true],
      reminderCycle: ['', [Validators.required, Validators.min(1), Validators.max(366)]]
    });
  }
  ngOnInit() {
    this.form.valueChanges.subscribe(() => {
      this.validateCheckbox();
      this.isFormChanging = true;
    });
    this.loadData();
  }
  loadData() {
    this.enterpriseService.getEnterpriseConfigNotification(this.scopeType, this.enterpriseId).subscribe(res => {
      if (res && res.success && res.data) {
        this.idConfig = res.data.id;
        this.isActive = res.data.isActive;
        let dataUsers = res.data.users.map(e => {
          return {
            ...e,
            type: 'USER'
          }
        });
        let dataDepartments = res.data.departments.map(e => {
          return {
            ...e,
            type: 'DEPARTMENT',
            representativeIsActive: e.isActiveRepresentative
          }
        });

        this.users = [
          ...dataDepartments,
          ...dataUsers
        ];
        this.form.patchValue({
          isSendSms: res.data.isSendSms,
          isSendEmail: res.data.isSendEmail,
          reminderCycle: res.data.period
        });
        this.isFormChanging = false;
      }
    });
  }

  validateCheckbox() {
    const isSendSms = this.form.get('isSendSms').value;
    const isSendEmail = this.form.get('isSendEmail').value;

    // Nếu cả 2 đều không được chọn thì set lỗi
    if (!isSendSms && !isSendEmail) {
      this.form.setErrors({ required: true });
    } else {
      this.form.setErrors(null); // Clear lỗi khi chọn lại
    }
  }
  isReminderCycleInvalid() {
    const reminderCycleControl = this.form.get('reminderCycle');
    return reminderCycleControl.invalid && (reminderCycleControl.dirty || reminderCycleControl.touched);
  }


  onChangeUserSearch(event): void {
    if (event.target.value.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.autoUserService.fetchConfigNotification(this.inputUserSignValue.trim())
        .then(result => {
          if (this.inputUserSignValue.trim().length > 0) {
            this.filteredUserOptions = result.sort(function (a, b) {
              return a.type.localeCompare(b.type)
            });
          } else {
            this.filteredUserOptions = [];
          }
        }).finally(() => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserSignValue = '';
      this.filteredUserOptions = [];
    }
  }
  autocompleteUserSignSelected($event: any, model: any) {
    if ($event.isUserInput) {
      const userId = model.type === 'USER' ? model.id : null;
      const userName = model.name;
      const departmentName = model.type === 'DEPARTMENT' ? model.departmentName : null;
      const departmentId = model.type === 'DEPARTMENT' ? model.departmentId : null;
      const email = model.email;
      const type = model.type;
      if (!this.checkExistedUserOrDepartment(userName, departmentName, userId, departmentId, email, type)) {
        let users = this.users;
        users = [
          ...this.users,
          {
            userId: model.type === 'USER' ? model.id : null,
            enterpriseId: model.enterpriseId,
            name: model.name,
            email: model.email,
            phone: model.phone,
            departmentName: model.type === 'DEPARTMENT' ? model.departmentName : null,
            departmentCode: model.type === 'DEPARTMENT' ? model.departmentCode : null,
            departmentId: model.type === 'DEPARTMENT' ? model.departmentId : null,
            type: model.type,
            representativeIsActive: model.type === 'DEPARTMENT' ? model.representativeIsActive : null,
            representativeId: model.type === 'DEPARTMENT' ? model.representativeId : null,
          }
        ];
        this.users = users;
        this.inputUserSignValue = '';
        this.isFormChanging = true;
      }
    }
  }

  checkExistedUserOrDepartment(userName: string, departmentName: string, userId: string, departmentId?: string, email?: string, type?: string) {
    let userExist;
    let departmentExist;
    if (type === 'USER') {
      userExist = this.users.find(user => user.userId === userId);
    } else {
      departmentExist = this.users.find(user => user.departmentId === departmentId);
    }
    if (userExist) {
      this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_user_apostrophe_duplicate_config_notification'), [userName + ' - ' + email]));
      return true;
    }
    if (departmentExist) {
      this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_department_apostrophe_duplicate_config_notification'), [departmentName]));
      return true;
    }
    return false;
  }

  onClickDeleteElementUser(element: any): void {
    this.isFormChanging = true;
    if (element.type === 'USER') {
      this.users = this.users.filter(d => d.userId !== element.userId);
    } else {
      this.users = this.users.filter(d => d.departmentId !== element.departmentId);
    }
  }
  onBtnCancelClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data_config')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.router.navigate(['/home-enterprise/analysis-report']);
        }
        dialogRe.close();
      });
    } else {
      this.router.navigate(['/home-enterprise/analysis-report']);
    }
  }
  onSubmit() {
    const dataForm = this.form.value;
    let userDataSave = [];
    let departmentDataSave = [];
    this.users.forEach(user => {
      if (user.type === 'USER') {
        let userAdd;
        if (user.id) {
          userAdd = {
            userId: user.userId,
            id: user.id
          }
        } else {
          userAdd = {
            userId: user.userId,
          }
        }
        userDataSave.push(userAdd);
      } else {
        let departmentAdd;
        if (user.id) {
          departmentAdd = {
            departmentId: user.departmentId,
            id: user.id
          }
        } else {
          departmentAdd = {
            departmentId: user.departmentId,
          }
        }
        departmentDataSave.push(departmentAdd);
      }
    });
    const body:any = {
      isActive: this.isActive,
      isSendSms: dataForm.isSendSms,
      isSendEmail: dataForm.isSendEmail,
      period: dataForm.reminderCycle,
      scopeType: this.scopeType,
      enterpriseId: this.enterpriseId,
      users: userDataSave,
      departments: departmentDataSave
    }
    if (this.idConfig) {
      body.id = this.idConfig;
    }
    this.enterpriseService.updateEnterpriseNotificationConfig(body).subscribe(res => {
      if (res && res.success) {
        console.log(res);
        if (this.idConfig) {
          this.toastr.success(this.message.getMessage('config_notification.message.update_config_notification_success'));
        } else {
          this.toastr.success(this.message.getMessage('config_notification.message.add_config_notification_success'));
        }
        this.isFormChanging = false;
        this.loadData();
      } else {
        this.toastr.error(res.message);
      }
    });
  }

  checkEnableSave() {
    let isDisable: boolean = true;
    const dataForm = this.form.value;
    if (!this.isActive) {
      if (this.isFormChanging) {
        isDisable = false;
      }
    } else {
      if (!this.form.errors && this.form.valid && this.users.length > 0 && this.isFormChanging) {
        isDisable = false;
      } else {
        isDisable = true;
      }
    }
    return isDisable;
  }

  ngOnDestroy(): void {
  }
  clickSend(data) {
    this.isActive = data;
    this.isFormChanging = true;
  }
  normalizeValue(event: FocusEvent) {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;
    if (value) {
      if (value.includes('.')) {
        // Số thập phân: Chuẩn hóa phần nguyên
        const [integerPart, decimalPart] = value.split('.');
        value = parseInt(integerPart || '0', 10) + '.' + (decimalPart || '');
      } else {
        // Số nguyên: Chuyển thành số bình thường
        value = parseInt(value, 10).toString();
      }
    }
    inputElement.value = value;
    this.form.patchValue({
      reminderCycle: value
    });
  }
  onlyNumber(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

}
